import {
  CREATE_KEG_COLLECTION_REQUEST,
  CREATE_KEG_COLLECTION_SUCCESS,
  CREATE_KEG_COLLECTION_FAILURE,
  CREATE_KEG_COLLECTION_CLEAR,
  CREATE_KEG_COLLECTION_QUEUE,
} from '../../../actions/actionTypes'

import fetchStatusReducerCreator from '../../fetchStatuses/higherOrderReducers/reducerCreators'

export default fetchStatusReducerCreator({})(
    CREATE_KEG_COLLECTION_REQUEST,
    CREATE_KEG_COLLECTION_SUCCESS,
    CREATE_KEG_COLLECTION_FAILURE,
    CREATE_KEG_COLLECTION_CLEAR,
    CREATE_KEG_COLLECTION_QUEUE
)
